<template>
  <section class="conversation">
    <Chatbot
      key="chatbot"
      class="chatbot"
      :flow="conversationFlow"
      @finished="() => null" />

    <Footer />
  </section>
</template>

<script>
import Chatbot from "@/components/chatbot/Chatbot"
import conversationFlow from "@/chatbot-flows/conversation.flow.js"
import Footer from "@/components/ui/Footer"

export default {
  name: "Conversation",
  components: {
    Chatbot,
    Footer
  },
  data() {
    return { conversationFlow }
  }
}
</script>

<style lang="scss" scoped>
.conversation {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;

  .chatbot {
    flex: 1;
  }
}
</style>
